<template>
  <span>
    <v-row class="s1">
      <v-col cols="12" md="5" lg="6" class="s1-left">
        <span class="s1-left_text">The tokenized solution</span>
        <span class="s1-left_text white--text">for Betting</span>
      
        <div class="supply">
          <v-img
            class="supply-img"
            contain
            :src="require('@/assets/img/phder.png')"
            :lazy-src="require('@/assets/img/phder.png')"
          ></v-img>
        </div>
        
        <v-btn
          class="s1-left_pitch"
          href="https://goodgame.finance/ggt_pitchdeck.pdf"
          target="blank"
          >read our pitch deck</v-btn
        >
      </v-col>
      <v-col cols="12" lg="6" md="5" sm="12" class="s1-right">
        <v-img
          class="s1-right_img"
          contain
          :src="require('@/assets/img/final.png')"
          :lazy-src="require('@/assets/img/final.png')"
        ></v-img>
      </v-col>
    </v-row>

    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" sm="12">
          <FeatureGames :games="games" />
        </v-col>
      </v-row>
    </v-container>
  </span>
</template>

<script>
import FeatureGames from '../components/FeaturedGames';
export default {
  name: "Overview",
  components: {
    FeatureGames
  },
  props: {
    games: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.supply {
  align-self: unset;
  margin-left: 100px;

  @media screen and (min-width: 1921px) {
    align-self: flex-end;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    align-self: center;
    margin-left: 0px;
  }

  @media screen and (max-width: 767px) {
    align-self: center;
    margin-left: 0px;
  }
}

.supply-img {
  margin: 25px 0px;
  width: 550px;

  @media screen and (min-width: 1921px) {
    width: 760px;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    width: 400px;
  }

  @media (max-width: 1024px) {
    width: 450px;
  }

  @media screen and (max-width: 375px) {
    width: 319px;
  }

  @media (max-width: 767px) {
    // width: 100%;
    max-width: 400px;
  }

}
</style>

